import { render, staticRenderFns } from "./Toast.vue?vue&type=template&id=6b20226a&scoped=true&"
import script from "./Toast.vue?vue&type=script&lang=js&"
export * from "./Toast.vue?vue&type=script&lang=js&"
import style0 from "./Toast.vue?vue&type=style&index=0&id=6b20226a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b20226a",
  null
  
)

export default component.exports